import { render, staticRenderFns } from "./NewAffiliate.vue?vue&type=template&id=f958fa00&"
import script from "./NewAffiliate.vue?vue&type=script&lang=ts&"
export * from "./NewAffiliate.vue?vue&type=script&lang=ts&"
import style0 from "./NewAffiliate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports